import { render, staticRenderFns } from "./starting-a-new-job.vue?vue&type=template&id=2a4bfa1a"
import script from "./starting-a-new-job.vue?vue&type=script&lang=js"
export * from "./starting-a-new-job.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports